import React, { useState } from "react";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";
import { Typography, Modal } from "@mui/material";
import BedIcon from '@mui/icons-material/Bed';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import { Table } from "react-bootstrap";
import "./Leaves.css";

const BedAllotment = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFloor, setSelectedFloor] = useState("");
    const [selectedRoom, setSelectedRoom] = useState("");
    const [rooms, setRooms] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedBed, setSelectedBed] = useState(null);
    const [bedDetails, setBedDetails] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [searchedFloor, setSearchedFloor] = useState("");

    const allRooms = [
        { roomNumber: "101", floor: "1", beds: Array(10).fill({ occupied: true }).fill({ occupied: false }, 6) },
        { roomNumber: "102", floor: "1", beds: Array(10).fill({ occupied: true }).fill({ occupied: false }, 7) },
        { roomNumber: "103", floor: "1", beds: Array(10).fill({ occupied: true }).fill({ occupied: false }, 4) },
        { roomNumber: "201", floor: "2", beds: Array(10).fill({ occupied: true }) },
        { roomNumber: "202", floor: "2", beds: Array(10).fill({ occupied: true }).fill({ occupied: false }, 8) },
        { roomNumber: "203", floor: "2", beds: Array(10).fill({ occupied: true }).fill({ occupied: false }, 5) },
        { roomNumber: "301", floor: "3", beds: Array(10).fill({ occupied: true }).fill({ occupied: false }, 3) },
        { roomNumber: "302", floor: "3", beds: Array(10).fill({ occupied: true }).fill({ occupied: false }, 6) },
        { roomNumber: "303", floor: "3", beds: Array(10).fill({ occupied: true }).fill({ occupied: false }, 7) },
    ];

    const handleFloorChange = (e) => {
        setSelectedFloor(e.target.value);
    };

    const handleRoomNumberChange = (e) => {
        setSelectedRoom(e.target.value);
    };

    const handleSearch = () => {
        let filteredRooms = allRooms.filter(room => room.floor === selectedFloor);
        if (selectedRoom) {
            filteredRooms = filteredRooms.filter(room => room.roomNumber === selectedRoom);
        }
        setRooms(filteredRooms);
        setSearchedFloor(selectedFloor);
    };

    const handleBedClick = (roomNumber, bedIndex, occupied) => {
        setSelectedBed({ roomNumber, bedIndex });
        setIsEdit(occupied);

        if (occupied) {
            setBedDetails({
                studentName: "Aditya",
                gender: "Male",
                course: "B.Tech",
                durationFrom: "2024-01-01",
                durationTo: "2024-12-31",
                floorNumber: selectedFloor,
                roomNumber: roomNumber,
            });
        } else {
            setBedDetails({});
        }

        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedBed(null);
        setIsEdit(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setBedDetails(prevDetails => ({
            ...prevDetails,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setRooms((prevRooms) =>
            prevRooms.map((room) =>
                room.roomNumber === selectedBed.roomNumber
                    ? {
                        ...room,
                        beds: room.beds.map((bed, index) =>
                            index === selectedBed.bedIndex ? { occupied: true } : bed
                        ),
                    }
                    : room
            )
        );

        handleClose();
    };

    return (
        <div>
            <TopLoader loading={isLoading ? "50" : "100"} />
            <div className="row col-12 d-flex justify-content-center mt-5 bg-white"></div>
            <div className="px-0 px-md-3">
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="">{t("Hostel Bed Allotment")}</h5>
                    </div>
                </div>

                <div className="row">
                    <div className="col-4">
                        <label htmlFor="floor" className="form-group">
                            Floor Number
                        </label>
                        <select className="common-input form-select"
                            id="floor"
                            value={selectedFloor}
                            onChange={handleFloorChange}
                        >
                            <option value="">Select Floor</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                        </select>
                    </div>
                    <div className="col-4">
                        <label htmlFor="room" className="form-group">
                            Room number(Optional)
                        </label>
                        <select className="common-input form-select"
                            id="roomnumber"
                            onChange={handleRoomNumberChange}
                        >
                            <option value="">Select Room</option>
                            {allRooms
                                .filter(room => room.floor === selectedFloor)
                                .map(room => (
                                    <option key={room.roomNumber} value={room.roomNumber}>
                                        {room.roomNumber}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <div className="col-4 d-flex align-items-end">
                        <Typography
                            variant="button"
                            className="primary-btn btn col-6"
                            id="btn"
                            onClick={handleSearch}
                        >
                            {t("Search")}
                        </Typography>
                    </div>
                </div>

                {searchedFloor && (
                    <>
                        <h5 className="mt-5">Bed Details</h5>
                        <div className="card mt-3">
                            <div className="card-body">
                                <h5 className="mt-2">Floor Number : {searchedFloor}</h5>
                                <Table bordered className="mt-3" style={{ height: '215px' }}>
                                    <thead>
                                        <tr>
                                            <th>Room Number</th>
                                            <th>Occupied/Available Beds</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rooms.map((room) => (
                                            <tr key={room.roomNumber}>
                                                <td>{room.roomNumber}</td>
                                                <td>
                                                    {room.beds.map((bed, index) =>
                                                        <div className="bed-icon-container" key={index} onClick={() => handleBedClick(room.roomNumber, index, bed.occupied)}>
                                                            <span className="bed-number mt-3">{index + 1}</span>
                                                            {bed.occupied ? (
                                                                <BedIcon className="bed-icon mt-3" />
                                                            ) : (
                                                                <BedOutlinedIcon className="bed-icon mt-3" />
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div
                    style={{
                        position: "relative",
                        width: "90vw",
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: 8,
                        padding: 20,
                        marginTop: "14rem",
                        margin: "5rem",
                    }}
                >
                    <h2 className="fw-bold text-center">{t("Student Details")}</h2>
                    <button
                        onClick={handleClose}
                        style={{
                            position: "absolute",
                            right: "20px",
                            top: "20px",
                            border: "none",
                            background: "none",
                            fontSize: "1.5rem",
                            cursor: "pointer",
                        }}
                    >
                        &times;
                    </button>

                    <div className="my-4">
                        <div className="row d-flex justify-content-center">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col">
                                        <label>{t("Student Name")} <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            name="studentName"
                                            value={bedDetails.studentName || ""}
                                            onChange={handleInputChange}
                                            readOnly={isEdit}
                                        />
                                    </div>
                                    <div className="col">
                                        <label>{t("Gender")} <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            name="gender"
                                            value={bedDetails.gender || ""}
                                            onChange={handleInputChange}
                                            readOnly={isEdit}
                                        />
                                    </div>
                                    <div className="col">
                                        <label>{t("Course")} <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            name="course"
                                            value={bedDetails.course || ""}
                                            onChange={handleInputChange}
                                            readOnly={isEdit}
                                        />
                                    </div>
                                </div>

                                <div className="row mt-2">
                                    <div className="col">
                                        <label>{t("Duration")} <span style={{ color: 'red' }}>*</span></label>
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="date"
                                                max={new Date().toISOString().split("T")[0]}
                                                name="durationFrom"
                                                className="form-control"
                                                required
                                                value={bedDetails.durationFrom || ""}
                                                onChange={handleInputChange}
                                                readOnly={isEdit}
                                            />
                                            <span style={{ margin: '0 10px' }}>-</span>
                                            <input
                                                type="date"
                                                min={new Date().toISOString().split("T")[0]}
                                                name="durationTo"
                                                className="form-control"
                                                required
                                                value={bedDetails.durationTo || ""}
                                                onChange={handleInputChange}
                                                readOnly={isEdit}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <label>{t("Floor Number")} <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="number"
                                            readOnly
                                            className="form-control"
                                            value={selectedFloor}
                                        />
                                    </div>
                                    <div className="col">
                                        <label>{t("Room Number")} <span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            type="number"
                                            readOnly
                                            className="form-control"
                                            value={selectedBed?.roomNumber || ""}
                                        />
                                    </div>
                                </div>
                                {!isEdit && (
                                    <div className="row d-flex mt-2">
                                        <div className="col justify-content-center text-center">
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-lg"
                                                style={{ marginTop: "1rem" }}
                                            >
                                                {t("Submit")}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default BedAllotment;
